import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getOrganizationEnums, updateOrganizationEnums } from '../api/settingsApi';
import { DEFAULT_ORGANIZATION_ENUMS, OrganizationEnums } from '../utils/organizationEnums';

export function useOrganizationEnums() {
  return useQuery({
    queryKey: ['organizationEnums'],
    queryFn: getOrganizationEnums,
    placeholderData: DEFAULT_ORGANIZATION_ENUMS,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateOrganizationEnums() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (enums: OrganizationEnums) => updateOrganizationEnums(enums),
    onSuccess: (data) => {
      queryClient.setQueryData(['organizationEnums'], data);
    },
  });
}
